import { render, staticRenderFns } from "./auctionSession.vue?vue&type=template&id=138590e2&scoped=true"
import script from "./auctionSession.vue?vue&type=script&lang=js"
export * from "./auctionSession.vue?vue&type=script&lang=js"
import style0 from "./auctionSession.vue?vue&type=style&index=0&id=138590e2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138590e2",
  null
  
)

export default component.exports